import { jsx as _jsx } from "react/jsx-runtime";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { GraphPage } from "./features/GraphConnectionBuilder/view/GraphPage/GraphPage";
export const AppRoutes = () => {
    return (_jsx(Router, { children: _jsx(Routes, { children: _jsx(Route, { path: "/", element: _jsx(GraphPage, {}) }) }) }));
};
